import { createSelector } from 'reselect';
import { get, isNil } from 'lodash/fp';

function getFilters(filters) {
  return Object.entries(filters).reduce((memo, [key, value]) => {
    if (isNil(value) || (Array.isArray(value) && value.length === 0)) {
      return memo;
    }
    return {
      ...memo,
      [key]: value
    };
  }, {});
}

const lobbyFiltersSelector = createSelector(
  get('lobbyChallenges.filters'),
  getFilters
);

export default lobbyFiltersSelector;
